import { render, staticRenderFns } from "./VCandidateInvite.vue?vue&type=template&id=77bb9374&scoped=true&lang=pug"
import script from "./VCandidateInvite.vue?vue&type=script&lang=ts"
export * from "./VCandidateInvite.vue?vue&type=script&lang=ts"
import style0 from "./VCandidateInvite.vue?vue&type=style&index=0&id=77bb9374&prod&lang=sass&scoped=true"
import style1 from "./VCandidateInvite.vue?vue&type=style&index=1&id=77bb9374&prod&lang=sass"
import style2 from "./VCandidateInvite.vue?vue&type=style&index=2&id=77bb9374&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb9374",
  null
  
)

/* custom blocks */
import block0 from "./VCandidateInvite.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FCandidateInvite%2FVCandidateInvite.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports